import { TraceName } from '@core/types';

export class Trace {
  date: Date;
  name: TraceName;
  key?: string;
}
